<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <rect x="3" y="9" width="18" height="6" rx="1"/>
  </svg>
</template>

<script>
export default {
  name: 'InlineDisplay'
}
</script>
